/**
 * Button — primary CTA, secondary, on-dark variants, and a ghost text-link.
 * Renders an <a> when href is provided, otherwise a <button>.
 */
export default function Button({
  variant = 'primary',
  href,
  children,
  icon,
  className,
  style,
  ...rest
}) {
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    fontFamily: 'var(--font-body)',
    fontWeight: 500,
    fontSize: 15,
    padding: '13px 26px',
    borderRadius: 999,
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'all 250ms var(--ease-out)',
    letterSpacing: '0.01em',
    whiteSpace: 'nowrap',
  };
  const variants = {
    primary: {
      background: 'var(--blue-deep)',
      color: 'var(--cream)',
      boxShadow: 'var(--shadow-cta)',
    },
    secondary: {
      background: 'transparent',
      color: 'var(--ink)',
      boxShadow: 'inset 0 0 0 1px rgba(45,42,38,0.18)',
    },
    onDark: {
      background: 'var(--cream)',
      color: 'var(--ink)',
    },
    onDarkOutline: {
      background: 'transparent',
      color: 'var(--cream)',
      boxShadow: 'inset 0 0 0 1px rgba(246,241,234,0.30)',
    },
    ghost: {
      background: 'transparent',
      color: 'var(--ink)',
      padding: '10px 4px',
    },
  };

  const Tag = href ? 'a' : 'button';
  return (
    <Tag href={href} className={className} style={{ ...base, ...variants[variant], ...style }} {...rest}>
      {children}
      {icon}
    </Tag>
  );
}
